import { render, staticRenderFns } from "./DauChartAdmin.vue?vue&type=template&id=cae1899c"
import script from "./DauChartAdmin.vue?vue&type=script&lang=js"
export * from "./DauChartAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports